
const Recommended = [
  {

    productId: 245000673560175,
    productRef: 256345160175,
    title: "6 BEDROOM DUPLEX, LEKKI",
    shortDescription: "Neat, serene, landmarks that supports your lifestyle.",
    imageURL: `https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg`,
    productName: '6 BEDROOM DUPLEX, LEKKI',
      imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl4:  'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595550888/shop/adverts/1-duplex_brpxjq.jpg',
      videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
      dummyUrl: '../../images/product1/emeraldStone.jpg',
      availability: true,
      city: 'Lekki',
      state: 'Lagos',
      areaName: 'Lekki',
      price: 1500,
      currency: ' ₦',
      locationImg: `${`📍`}`,
      priceImg: `${`💵`}`,
      description: `
      Features:\n
       
      
      ---
      
      ✨ Key Features  
      - Fully detached duplex with privacy  
      - Large green outdoor space + sit-out bar  
      - Superfast internet (Starlink & CSS Fiber)  
      - 24/7 power (inverter + soundproof gen)  
      - Smart TVs, ACs, Netflix, Prime  
      - PS5 & Oculus (on request)  
      - Daily cleaning + complimentary breakfast  
      - Secure estate with ample parking
      `,
  },
  {

    productId: 245000673560176,
    productRef: 256345160176,
    title: "5 BEDROOM DUPLEX, AGUNGI",
    shortDescription: "Neat, serene, landmarks that supports your lifestyle.",
    imageURL: `https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg`,
    productName: '5 BEDROOM DUPLEX, AGUNGI',
      imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl4:  'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
      dummyUrl: '../../images/product1/emeraldStone.jpg',
      availability: true,
      city: 'Lekki',
      state: 'Lagos',
      areaName: 'Agungi',
      price: 1500,
      locationImg: `${`📍`}`,
      priceImg: `${`💵`}`,
      currency: ' ₦',
      description: `
      Features:\n
      
      ---
      
      ✨ Key Features  
      - Fully detached duplex with privacy  
      - Large green outdoor space + sit-out bar  
      - Superfast internet (Starlink & CSS Fiber)  
      - 24/7 power (inverter + soundproof gen)  
      - Smart TVs, ACs, Netflix, Prime  
      - PS5 & Oculus (on request)  
      - Daily cleaning + complimentary breakfast  
      - Secure estate with ample parking
      `,
  },
  {

    productId: 245000673560177,
    productRef: 256345160177,
    title: "SERVICED APARTMENT, MAITAMA",
    shortDescription: "Neat, serene, landmarks that supports your lifestyle.",
    imageURL: `https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551659/shop/adverts/apartment_o6bcix.jpg`,
    productName: 'SERVICED APARTMENT, MAITAMA',
      imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl4:  'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595551255/shop/adverts/5bedroom_qnh7fr.jpg',
      videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
      dummyUrl: '../../images/product1/emeraldStone.jpg',
      availability: true,
      city: 'Abuja',
      state: 'FCT',
      areaName: 'Maitama',
      price: 1500,
      locationImg: `${`📍`}`,
      priceImg: `${`💵`}`,
      currency: ' ₦',
      description: `
      Features:\n
      🌞 Day Booking (7am–6pm): ₦150K  
      🌙 Night Booking (7pm–6am): ₦150K  
      🍽️ Includes one complimentary meal
      
      ---
      
      ✨ Key Features  
      - Built with privacy spaces  
      - Large green outdoor space + sit-out bar  
      - Superfast internet (Starlink & CSS Fiber)  
      - 24/7 power (inverter + soundproof gen)  
      - Smart TVs, ACs, Netflix, Prime  
      - PS5 & Oculus (on request)  
      - Daily cleaning + complimentary breakfast  
      - Secure estate with ample parking
      `,
  },
];

export default Recommended;